export default "__VITE_ASSET__Ba3OD20L__"